export const whatsAppConsumption = "/analytics_dashboard/:app_group_id/whats_app_credit_consumption_detail_data";
